module.exports = __webpack_public_path__ + "static/kw51_img_7-4d8656c7f6d98f78eabe848bca4ec3a3.png";